const productUnits = ["UN", "JG", "MT", "LT", "KG"];

export default productUnits;
